import type { TranslationTree } from '../../locale.model';

export const pagesPtBr: TranslationTree = {
  manufacturers: {
    title: 'Fabricantes',
    subtitle: 'Gerencie os fabricantes disponíveis para licenciamento.',
    newButton: 'Novo Fabricante',
    summaryAria: 'Resumo de fabricantes',
    registered: 'Cadastrados',
    searchPlaceholder: 'Pesquisar fabricantes...',
    loading: 'Carregando fabricantes...',
    empty: 'Nenhum fabricante encontrado.',
    table: {
      manufacturer: 'Fabricante',
      description: 'Descrição',
      createdAt: 'Criado em',
      actions: 'Ações',
    },
    editAria: 'Editar fabricante',
    deleteAria: 'Excluir fabricante',
    delete: {
      title: 'Confirmar exclusão',
      message: 'Deseja realmente remover o fabricante {{name}}?',
      cancel: 'Cancelar',
      confirm: 'Excluir',
      deleting: 'Excluindo...',
    },
    form: {
      editTitle: 'Editar fabricante',
      createTitle: 'Novo fabricante',
      subtitle: 'Preencha os dados para cadastrar ou atualizar o fabricante.',
      name: 'Nome',
      description: 'Descrição',
      cancel: 'Cancelar',
      saving: 'Salvando...',
      saveChanges: 'Salvar alterações',
      create: 'Criar fabricante',
    },
  },
  resellers: {
    title: 'Gestão de Revendedores',
    subtitle: 'Cadastre e gerencie seus revendedores parceiros.',
    summaryAria: 'Resumo de revendedores',
    stats: {
      total: 'Total de Revendedores',
      active: 'Revendedores Ativos',
      inactive: 'Revendedores Inativos',
      filtered: 'Filtrados',
    },
    searchPlaceholder: 'Buscar por código, nome, email ou região...',
    statusFilter: {
      all: 'Todos',
      active: 'Ativos',
      inactive: 'Inativos',
    },
    commissionReport: 'Relatório de Comissões',
    newButton: 'Novo Revendedor',
    loading: 'Carregando revendedores...',
    empty: 'Nenhum revendedor encontrado.',
    table: {
      code: 'Código',
      name: 'Nome / Razão Social',
      contact: 'Contato',
      region: 'Região',
      clients: 'Clientes',
      status: 'Status',
      inactiveAt: 'Data de inativação',
      actions: 'Ações',
    },
    clientsCount: '{{count}} cliente(s)',
    statusActive: 'Ativo',
    statusInactive: 'Inativo',
    moreActionsAria: 'Mais ações',
    edit: 'Editar',
    remove: 'Remover',
    report: {
      title: 'Relatório de Comissões',
      subtitle: 'Relatório de comissões por revendedor baseado nos clientes vinculados.',
      period: 'Período: Mês Atual',
      taxRate: 'Taxa (%):',
      baseTotal: 'Base Total',
      commissionTotal: 'Total Comissões',
      averagePerReseller: 'Média por Revendedor',
      table: {
        code: 'Código',
        reseller: 'Revendedor',
        clients: 'Clientes',
        baseValue: 'Valor Base',
        tax: 'Taxa',
        commission: 'Comissão',
        status: 'Status',
      },
      noData: 'Nenhum dado de comissão disponível.',
      footer: '{{resellers}} revendedor(es) com {{clients}} cliente(s) no total.',
      close: 'Fechar',
      exportPdf: 'Exportar PDF',
      statusPending: 'Pendente',
    },
    form: {
      editTitle: 'Editar Revendedor',
      createTitle: 'Novo Revendedor',
      subtitle: 'Preencha as informações do revendedor.',
      code: 'Código',
      status: 'Status',
      name: 'Nome / Razão Social',
      email: 'E-mail',
      phone: 'Telefone',
      region: 'Região',
      cancel: 'Cancelar',
      saving: 'Salvando...',
      saveChanges: 'Salvar alterações',
      create: 'Cadastrar Revendedor',
      errors: {
        phoneInvalid: 'Informe um telefone válido ou limpe o campo.',
        required: 'Preencha código, status e nome/razão social.',
      },
    },
    clientsModal: {
      title: 'Clientes de {{name}}',
      subtitle: 'Código: {{code}} - {{count}} cliente(s) vinculado(s)',
      searchPlaceholder: 'Buscar por empresa, CNPJ ou nome...',
      linked: 'Vinculados ({{count}})',
      available: 'Disponíveis ({{count}})',
      loading: 'Carregando clientes vinculados...',
      noLinked: 'Nenhum cliente vinculado',
      allLinked: 'Todos os clientes já estão vinculados',
      linking: 'Vinculando...',
      link: 'Vincular',
      close: 'Fechar',
    },
    delete: {
      title: 'Confirmar exclusão',
      message: 'Deseja realmente remover o revendedor {{name}}?',
      cancel: 'Cancelar',
      confirm: 'Excluir',
      deleting: 'Excluindo...',
    },
  },
  menus: {
    title: 'Menus',
    subtitle: 'Gerencie os menus e submenus do sistema.',
    addMenu: 'Adicionar menu',
    summaryAria: 'Resumo de menus',
    registered: 'Menus cadastrados',
    submenus: 'Submenus',
    searchPlaceholder: 'Buscar menus e submenus...',
    expandAll: 'Expandir tudo',
    collapseAll: 'Colapsar tudo',
    loading: 'Carregando menus...',
    emptySearch: 'Nenhum menu encontrado para a busca.',
    empty: 'Nenhum menu cadastrado.',
    reorderHint:
      'Use ↑↓ ou arraste pelo ⋮⋮ para reordenar. O número à esquerda reflete a ordem salva no banco. Menus só podem ser movidos dentro da mesma seção.',
    clearSearchToReorder: 'Limpe a busca para reordenar menus e submenus.',
    sectionInfo: 'Seção: {{section}} (order_section: {{orderSection}}) · {{count}} submenu(s)',
    sectionGroupAria: 'Seção {{section}}',
    sectionGroupMeta: '{{count}} menu(s) · order_section: {{orderSection}}',
    sectionGroupBadge: 'Seção',
    expandSectionAria: 'Expandir ou recolher seção {{section}}',
    menuSubmenuCount: '{{count}} submenu(s)',
    moveUpMenu: 'Subir menu',
    moveDownMenu: 'Descer menu',
    expandSubmenusAria: 'Expandir ou recolher submenus de {{title}}',
    addSubmenu: '+ Submenu',
    editMenuAria: 'Editar menu',
    deleteMenuAria: 'Excluir menu',
    dragMenuAria: 'Arrastar menu',
    dragMenuTitle: 'Arrastar para reordenar menu',
    noSubmenus: 'Nenhum submenu cadastrado.',
    marker: 'Marcador: {{bullet}}',
    moveUpSubmenu: 'Subir submenu',
    moveDownSubmenu: 'Descer submenu',
    editSubmenuAria: 'Editar submenu',
    deleteSubmenuAria: 'Excluir submenu',
    dragSubmenuAria: 'Arrastar submenu',
    dragSubmenuTitle: 'Arrastar para reordenar submenu',
    deleteMenu: {
      title: 'Excluir menu',
      message: 'Tem certeza que deseja excluir {{title}}? Todos os submenus serão removidos.',
      cancel: 'Cancelar',
      confirm: 'Excluir',
      deleting: 'Excluindo...',
    },
    deleteSubmenu: {
      title: 'Excluir submenu',
      message: 'Tem certeza que deseja excluir {{title}}? Esta ação não pode ser desfeita.',
      cancel: 'Cancelar',
      confirm: 'Excluir',
      deleting: 'Excluindo...',
    },
    menuForm: {
      editTitle: 'Editar menu',
      createTitle: 'Adicionar menu',
      subtitle: 'Preencha os dados do menu principal.',
      title: 'Título',
      path: 'Caminho',
      section: 'Seção',
      svg: 'SVG',
      saxIcon: 'Ícone Sax',
      orderSection: 'Ordem da seção',
      orderHint: 'A ordem do menu na lista é definida por arrastar na tela principal.',
      cancel: 'Cancelar',
      saving: 'Salvando...',
      saveChanges: 'Salvar alterações',
      create: 'Criar menu',
    },
    submenuForm: {
      editTitle: 'Editar submenu',
      createTitle: 'Adicionar submenu',
      subtitle: 'Preencha os dados do submenu.',
      title: 'Título',
      path: 'Caminho',
      marker: 'Marcador',
      saxIcon: 'Ícone Sax',
      cancel: 'Cancelar',
      saving: 'Salvando...',
      saveChanges: 'Salvar alterações',
      create: 'Criar submenu',
    },
    bullet: {
      bullet: 'Bullet (ponto)',
      line: 'Line (linha)',
    },
  },
  ambience: {
    title: 'Ambiência',
    subtitle: 'Gerencie itens de ambientação e seus tipos para o sistema.',
    tabs: {
      items: 'Itens de ambientação',
      types: 'Tipos de itens',
    },
    addItem: 'Adicionar Item',
    addType: 'Adicionar tipo de item',
    loadingItems: 'Carregando itens...',
    emptyItems: 'Nenhum item de ambientação encontrado.',
    loadingTypes: 'Carregando tipos...',
    emptyTypes: 'Nenhum tipo de item encontrado.',
    table: {
      icon: 'Ícone',
      name: 'Nome',
      type: 'Tipo',
      description: 'Descrição',
      actions: 'Ações',
    },
    editItemAria: 'Editar item',
    deleteItemAria: 'Excluir item',
    editTypeAria: 'Editar tipo',
    deleteTypeAria: 'Excluir tipo',
    typeForm: {
      editTitle: 'Editar tipo de item',
      createTitle: 'Adicionar tipo de item',
      editHint: 'Atualize os dados do tipo de item de ambientação.',
      createHint: 'Adicione um novo tipo item de ambientação para o seu sistema.',
      name: 'Nome',
      description: 'Descrição',
      saving: 'Salvando...',
      save: 'Salvar',
      cancel: 'Cancelar',
    },
    itemForm: {
      editTitle: 'Editar item',
      createTitle: 'Adicionar item',
      editHint:
        'Atualize os dados do item de ambientação. O ícone só será substituído se um novo arquivo for enviado.',
      createHint: 'Adicione um novo item de ambientação para o seu sistema.',
      iconPreviewAlt: 'Pré-visualização do ícone',
      currentIconAlt: 'Ícone atual',
      name: 'Nome',
      itemType: 'Tipo de item',
      noTypeAvailable: 'Nenhum tipo disponível',
      icon: 'Ícone',
      iconOptional: ' (opcional)',
      keepCurrentIcon: 'Manter ícone atual',
      noFile: 'Nenhum arquivo selecionado',
      browse: 'Browse',
      saving: 'Salvando...',
      save: 'Salvar',
      cancel: 'Cancelar',
    },
    deleteType: {
      title: 'Confirmar exclusão',
      message: 'Deseja realmente excluir o tipo {{name}}?',
      cancel: 'Cancelar',
      confirm: 'Excluir',
      deleting: 'Excluindo...',
    },
    deleteItem: {
      title: 'Confirmar exclusão',
      message: 'Deseja realmente excluir o item {{name}}?',
      cancel: 'Cancelar',
      confirm: 'Excluir',
      deleting: 'Excluindo...',
    },
    feedback: {
      typeUpdated: 'Tipo atualizado',
      typeUpdatedMessage: 'O tipo "{{name}}" foi atualizado com sucesso.',
      typeCreated: 'Tipo criado',
      typeCreatedMessage: 'O tipo "{{name}}" foi cadastrado com sucesso.',
      typeDeleted: 'Tipo excluído',
      typeDeletedMessage: 'O tipo "{{name}}" foi excluído com sucesso.',
      typeErrorCreate: 'Erro ao criar tipo',
      typeErrorUpdate: 'Erro ao atualizar tipo',
      typeErrorDelete: 'Erro ao excluir tipo',
      itemUpdated: 'Item atualizado',
      itemUpdatedMessage: 'O item "{{name}}" foi atualizado com sucesso.',
      itemCreated: 'Item criado',
      itemCreatedMessage: 'O item "{{name}}" foi cadastrado com sucesso.',
      itemDeleted: 'Item excluído',
      itemDeletedMessage: 'O item "{{name}}" foi excluído com sucesso.',
      itemErrorCreate: 'Erro ao criar item',
      itemErrorUpdate: 'Erro ao atualizar item',
      itemErrorDelete: 'Erro ao excluir item',
      ok: 'OK',
    },
  },
  palettes: {
    list: {
      title: 'Padrões de cores',
      newButton: 'Novo padrão de cor',
      loading: 'Carregando paletas...',
      empty: 'Nenhuma paleta de cores encontrada.',
      table: {
        name: 'Nome',
        action: 'Ação',
      },
      editAria: 'Editar paleta',
      deleteAria: 'Excluir paleta',
      delete: {
        title: 'Confirmar exclusão',
        message: 'Deseja realmente excluir a paleta {{name}}?',
        cancel: 'Cancelar',
        confirm: 'Excluir',
        deleting: 'Excluindo...',
      },
      feedback: {
        deleted: 'Paleta excluída',
        deletedMessage: 'A paleta "{{name}}" foi excluída com sucesso.',
        deleteError: 'Erro ao excluir paleta',
        ok: 'OK',
      },
    },
    form: {
      editTitle: 'Editar padrão de cor',
      createTitle: 'Novo padrão de cor',
      loading: 'Carregando paleta...',
      nameLabel: 'Nome do padrão',
      sections: {
        cardColors: 'Cores do card',
        loginScreen: 'Tela de login',
        securityDashboard: 'Dashboard de segurança',
        dashboard: 'Dashboard',
        verticalMenu: 'Menu vertical',
        horizontalMenu: 'Menu horizontal',
        priorities: 'Prioridades',
      },
      light: 'Light',
      dark: 'Dark',
      card: 'Card',
      colorN: 'Cor {{index}}',
      priorityLevel: 'priority.level_{{level}}',
      cancel: 'Cancelar',
      saving: 'Salvando...',
      save: 'Salvar',
      create: 'Criar',
      validation: 'Validação',
      nameRequired: 'Informe o nome do padrão.',
      notFound: 'Paleta não encontrada.',
      backToList: 'Voltar para padrões de cores',
      feedback: {
        updated: 'Paleta atualizada',
        created: 'Paleta criada',
        successMessage: 'A paleta "{{name}}" foi {{action}} com sucesso.',
        errorCreate: 'Erro ao criar paleta',
        errorUpdate: 'Erro ao atualizar paleta',
        ok: 'OK',
      },
      fields: {
        background: 'Cor de fundo',
        darkBackground: 'Cor de fundo escuro',
        accent: 'Cor de destaque',
        text: 'Cor do texto',
        contrast: 'Cor de contraste',
        iconAccent: 'Cor de destaque do ícone',
        primary1: 'Cor primária 1',
        primary2: 'Cor primária 2',
        primary3: 'Cor primária 3',
        primaryBlack1: 'Cor primária preta 1',
        primaryBlack2: 'Cor primária preta 2',
        primaryBlack3: 'Cor primária preta 3',
        primaryLight1: 'Cor primária clara 1',
        primaryLight2: 'Cor primária clara 2',
        primaryLight3: 'Cor primária clara 3',
        secondary1: 'Cor secundária 1',
        secondary2: 'Cor secundária 2',
        secondary3: 'Cor secundária 3',
        secondary4: 'Cor secundária 4',
        secondary5: 'Cor secundária 5',
        secondary6: 'Cor secundária 6',
        secondary7: 'Cor secundária 7',
        secondary8: 'Cor secundária 8',
        secondary9: 'Cor secundária 9',
        secondary10: 'Cor secundária 10',
      },
    },
  },
  clients: {
    title: 'Empresas',
    subtitle: 'Crie, edite ou remova empresas, com vínculo de vertical e fabricantes.',
    newButton: 'Nova Empresa',
    summaryAria: 'Resumo de empresas',
    registered: 'Cadastradas',
    searchPlaceholder: 'Pesquisar empresas...',
    filterInstallation: 'Instalação',
    filterStatus: 'Status',
    filterAllInstallation: 'Todas',
    filterAllStatus: 'Todos',
    searchHint: 'A pesquisa por texto filtra apenas os resultados da página atual.',
    loading: 'Carregando empresas…',
    refreshing: 'Atualizando a lista…',
    empty: 'Nenhuma empresa encontrada.',
    table: {
      company: 'Empresa',
      vertical: 'Vertical',
      installation: 'Instalação',
      createdAt: 'Data de criação',
      status: 'Status',
      actions: 'Ações',
    },
    licensingAria: 'Overview do licenciamento',
    licensingTitle: 'Licenciamento',
    editAria: 'Editar empresa',
    profilesAria: 'Gerenciar perfis',
    profilesTitle: 'Gerenciar perfis',
    usersAria: 'Gerenciar usuários',
    usersTitle: 'Gerenciar usuários',
    integrationsAria: 'Integrações',
    integrationsTitle: 'Integrações',
    deleteAria: 'Excluir empresa',
    delete: {
      title: 'Confirmar exclusão',
      message: 'Deseja realmente excluir a empresa {{name}}?',
      deleting: 'Excluindo a empresa…',
      cancel: 'Cancelar',
      confirm: 'Excluir',
    },
    success: {
      created: 'Empresa criada',
      createdMessage: '{{name}} foi cadastrada com sucesso. A lista foi atualizada.',
      deleted: 'Empresa excluída',
      deletedMessage: 'A empresa {{name}} foi excluída com sucesso. A lista foi atualizada.',
      updated: 'Empresa atualizada',
      updatedMessage: 'As alterações em {{name}} foram salvas com sucesso. A lista foi atualizada.',
      ok: 'OK',
    },
    editModal: {
      savingCreate: 'Criando a empresa…',
      savingEdit: 'Salvando alterações…',
      sectionsAria: 'Seções da empresa',
      tabs: {
        info: 'Informações gerais',
        config: 'Configurações',
        logos: 'Logos',
        ambientacao: 'Ambientação',
        analiticos: 'Analíticos',
        modulos: 'Módulos',
        licenca: 'Licença',
      },
      vertical: 'Vertical',
      name: 'Nome',
      legalName: 'Razão social',
      document: 'Documento',
      status: 'Status',
      installationType: 'Tipo de instalação',
      subdomain: 'Subdomínio',
      subdomainLocked: 'O subdomínio não pode ser alterado.',
      subdomainLockedTitle: 'O subdomínio não pode ser alterado após a criação da empresa',
      manufacturers: 'Fabricantes habilitados para a empresa',
      noManufacturers: 'Nenhum fabricante carregado.',
      logo: 'Logo',
      noPreview: 'Sem preview',
      logoUploadHint:
        'O envio do logotipo é feito em uma etapa separada para /company/:id/logo após salvar a empresa.',
      select: 'Selecione',
      active: 'Ativo',
      inactive: 'Inativo',
      legacyV1: 'v1 é modo legado.',
      cancel: 'Cancelar',
      saving: 'Salvando…',
      saveChanges: 'Salvar alterações',
      create: 'Criar empresa',
      cancelConfirmTitle: 'Descartar alterações?',
      errors: {
        waitSettings: 'Aguarde o carregamento das configurações.',
        settingsNotLoaded:
          'As configurações ainda não foram carregadas. Abra a aba «Configurações» e espere o fim do carregamento.',
        requiredCreate: 'Preencha vertical, nome, razão social, documento e subdomínio.',
        requiredEdit: 'Preencha vertical, nome, razão social e documento.',
        noStatus:
          'Nenhum status disponível. Verifique o endpoint de status ou as permissões de administrador.',
        invalidInstallation:
          'Selecione um tipo de instalação válido (Cloud, On-premise ou Híbrido).',
        moduleVersion: 'Selecione a versão da gestão de módulos (v1 ou v2).',
        logoUploadFailed: 'A empresa foi salva, mas o envio do logotipo falhou: {{error}}',
        selectStatus: 'Selecione o status da empresa.',
      },
      createTitle: 'Cadastro de nova empresa',
      editTitle: 'Editar empresa',
      subtitle: 'Verifique se a empresa já existe antes de prosseguir.',
      savingWait: 'Aguarde um instante, estamos nos comunicando com o servidor.',
      noStatusLoaded:
        'Nenhum status carregado. É necessário GET /v1/licensing/companies/statuses (admin).',
      modulesVersion: 'Versão da gestão de módulos',
      legacyV1Hint:
        'Caso for utilizar dessa forma, toda a gestão de perfis deve ser feita via módulo master da Fisitalview.',
      logoPreviewAlt: 'Preview da logo',
      loadingSettings: 'Carregando configurações…',
      sectionComingSoon: 'Conteúdo desta seção será adicionado em breve.',
      cancelEditTitle: 'Cancelar edição',
      cancelEditMessage:
        'Tem certeza que deseja cancelar a operação? As alterações não salvas serão descartadas.',
      continueEditing: 'Continuar editando',
      confirmCancel: 'Sim, cancelar',
      tabsExtra: {
        cores: 'Cores personalizadas',
        idioma: 'Idioma',
        localVisit: 'Local Visit',
        llms: 'LLMs',
      },
    },
    backToCompanies: 'Voltar para empresas',
    companyFallback: 'Empresa',
    editTitle: 'Editar',
    errors: {
      companyNotIdentified: 'Empresa não identificada.',
      operationFailed: 'Não foi possível concluir a operação.',
      sessionExpired: 'Sessão inválida ou expirada.',
    },
    workspace: {
      underConstruction: 'Área em construção para a empresa',
    },
    routesAccess: {
      title: 'Módulos',
      description:
        'Defina quais categorias e módulos esta empresa poderá visualizar no SaaS. Marcar a categoria libera todos os módulos com rota válida; é possível liberar módulos avulsos desmarcando itens específicos.',
      expandAll: 'Expandir tudo',
      collapseAll: 'Colapsar tudo',
      loading: 'Carregando módulos e categorias…',
      empty: 'Nenhuma categoria ou módulo cadastrado.',
      emptyCategory: 'Nenhum módulo nesta categoria.',
      incompleteRoute: 'Rota incompleta no catálogo',
      uncategorized: 'Sem categoria',
      errors: {
        waitLoading: 'Aguarde o carregamento dos módulos.',
        notLoaded: 'Os módulos ainda não foram carregados. Aguarde o fim do carregamento.',
      },
    },
    ambientPermissions: {
      title: 'Itens de ambientação liberados',
      description:
        'Defina quais itens de ambientação esta empresa poderá utilizar no sistema. Marcar o tipo libera todos os itens da categoria; é possível liberar itens avulsos desmarcando itens específicos.',
      loading: 'Carregando itens de ambientação…',
      empty: 'Nenhum tipo ou item de ambientação cadastrado.',
      emptyType: 'Nenhum item neste tipo.',
      errors: {
        waitLoading: 'Aguarde o carregamento dos itens de ambientação.',
        notLoaded:
          'Os itens de ambientação ainda não foram carregados. Aguarde o fim do carregamento.',
      },
    },
    entitlements: {
      loading: 'Carregando entitlements…',
      description:
        'Licenciamento server-side para clientes cloud/hybrid. Alterações aplicam-se imediatamente no fv-api cloud.',
      lastUpdated: 'Última atualização:',
      quotasTitle: 'Quotas e vigência',
      activeFrom: 'Ativa em (opcional)',
      expiresAt: 'Expira em (opcional)',
      locations: 'Locais',
      cameras: 'Câmeras',
      users: 'Usuários',
      sensors: 'Sensores',
      storageGb: 'Storage (GB)',
      manufacturers: 'Fabricantes',
      saveSuccess: 'Entitlements salvos com sucesso.',
      saveButton: 'Salvar entitlements',
      errors: {
        loadFailed: 'Não foi possível carregar os entitlements.',
        saveFailed: 'Falha ao salvar entitlements. Verifique os dados.',
      },
    },
    licenseTab: {
      loading: 'Carregando licença…',
      status: 'Status:',
      validity: 'Vigência',
      quotas: 'Quotas',
      history: 'Histórico',
      issuedAt: 'Emitida em',
      expiresAt: 'Expira em',
      download: 'Download',
      noLicense: 'Nenhuma licença emitida para este cliente.',
      generateTitle: 'Gerar nova licença (.lic)',
      fingerprintHint:
        'Cole o fingerprint gerado no servidor on-prem (`GET /license/fingerprint` ou script CLI).',
      fingerprint: 'Fingerprint (64 hex)',
      generating: 'Gerando…',
      generateButton: 'Gerar e baixar .lic',
      errors: {
        loadFailed: 'Não foi possível carregar os dados da licença.',
        fingerprintRequired: 'Informe o fingerprint da máquina on-prem.',
        generateFailed: 'Falha ao gerar a licença. Verifique os dados e a configuração cloud.',
        redownloadFailed: 'Não foi possível baixar esta licença de novo.',
      },
    },
    licensingOverview: {
      loading: 'Carregando dados…',
      entitlements: 'Entitlements',
      status: 'Status:',
      noLicense: 'Nenhuma licença emitida.',
      analytics: 'Analíticos:',
      manufacturers: 'Fabricantes:',
      fingerprint: 'Fingerprint:',
      usageUsers: 'Usuários cadastrados',
      usageLocations: 'Locais cadastrados',
      usageCameras: 'Câmeras cadastradas',
      usageSensors: 'Sensores cadastrados',
      usageStorage: 'Armazenamento utilizado',
      onPremiseHint:
        'Consumo real (cadastros vs limites) está disponível apenas para clientes cloud/hybrid. No on-premise, o uso é consultado no servidor local do cliente.',
      errors: {
        loadFailed: 'Não foi possível carregar os dados de licenciamento.',
      },
    },
    profileEdit: {
      sectionsAria: 'Seções do perfil',
      tabs: { general: 'Geral', routesModules: 'Rotas / Módulos' },
      warning:
        'As alterações neste perfil afetam os acessos de todos os usuários vinculados a ele. As rotas do perfil devem ser um subconjunto das rotas liberadas para a empresa.',
      warningUsers: 'todos os usuários',
      nameLabel: 'Nome do perfil',
      createTitle: 'Novo perfil',
      editTitle: 'Editar perfil',
      defaultName: 'Perfil',
      create: 'Criar perfil',
      errors: {
        nameRequired: 'Informe o nome do perfil.',
        nameRequiredDetailsTab: 'Informe o nome do perfil na aba «Detalhes».',
      },
    },
    profileRoutes: {
      helpTitle: 'Onde configurar',
      helpText:
        'Abra Clientes → ícone de perfil (escudo) → editar perfil → aba «Rotas / Módulos». Marque as categorias/módulos; use ↑↓ ou arraste pelo ⋮⋮ à direita; preencha «Nome da seção» e «Ícone no menu».',
      title: 'Rotas do perfil',
      subtitle: 'Subconjunto das rotas liberadas na empresa.',
      empty:
        'Nenhuma rota habilitada para a empresa. Configure primeiro a aba Módulos em Editar empresa.',
      columns: {
        order: 'Ordem',
        orderHint: 'Use ↑↓ para reordenar',
        category: 'Categoria',
        sectionName: 'Nome da seção',
        actions: 'Ações',
        module: 'Módulo',
        menuIcon: 'Ícone no menu',
      },
      drag: {
        moveCategoryUp: 'Subir categoria',
        moveCategoryDown: 'Descer categoria',
        moveModuleUp: 'Subir módulo',
        moveModuleDown: 'Descer módulo',
        dragCategory: 'Arrastar categoria',
        dragModule: 'Arrastar módulo',
      },
      placeholders: {
        sectionName: 'Nome no menu',
        checkCategory: 'Marque a categoria…',
        checkModule: 'Marque o módulo…',
      },
      errors: {
        waitLoading: 'Aguarde o carregamento dos módulos.',
        profileNotIdentified: 'Perfil não identificado.',
      },
    },
    profilesPage: {
      title: 'Perfis',
      registered: '{{count}} cadastrados',
      searchName: 'Nome',
      search: 'Procurar',
      clearFiltersAria: 'Limpar filtros',
      clear: 'Limpar',
      newButton: '+ Novo perfil',
      filters: { all: 'Todos', active: 'Ativos', inactive: 'Inativos' },
      loading: 'Carregando perfis…',
      empty: 'Nenhum perfil encontrado.',
      editAria: 'Editar perfil',
      deleteAria: 'Excluir perfil',
      toggleActiveAria: 'Perfil ativo — clique para desativar',
      toggleInactiveAria: 'Perfil inativo — clique para ativar',
      toggleActiveTitle: 'Ativo — clique para desativar',
      toggleInactiveTitle: 'Inativo — clique para ativar',
      delete: {
        title: 'Excluir perfil',
        message:
          'Tem certeza que deseja excluir o perfil {{name}}? Esta ação não pode ser desfeita.',
      },
    },
    usersPage: {
      title: 'Usuários',
      subtitle: 'Gerenciar usuários da empresa',
      refresh: 'Atualizar',
      addButton: 'Adicionar',
      meta: {
        registered: '{{count}} cadastrado(s)',
        page: 'Página {{page}} de {{totalPages}} ({{limit}} por página)',
      },
      refreshing: 'Atualizando…',
      loading: 'Carregando usuários…',
      master: 'Master',
      editAria: 'Editar usuário',
      deleteAria: 'Excluir usuário',
      empty: {
        none: 'Nenhum usuário cadastrado para esta empresa.',
        page: 'Nenhum usuário nesta página.',
      },
      delete: {
        title: 'Excluir usuário',
        message:
          'Tem certeza que deseja excluir o usuário {{name}}? Esta ação não pode ser desfeita.',
      },
      errors: {
        notFound: 'Empresa ou usuário não encontrado.',
        companyNotFound: 'Empresa não encontrada.',
        deleteDependencies: 'Não foi possível excluir o usuário (erro ao remover dependências).',
        loadFailed: 'Não foi possível carregar a lista de usuários.',
        deleteFailed: 'Não foi possível excluir o usuário.',
        invalidPagination: 'Parâmetros de paginação inválidos.',
        forbiddenList: 'Sem permissão para listar usuários desta empresa.',
        forbiddenDelete: 'Sem permissão para excluir usuários desta empresa.',
      },
    },
    userEdit: {
      createTitle: 'Novo usuário',
      editTitle: 'Editar dados do usuário',
      fields: {
        firstName: 'Primeiro nome',
        lastName: 'Sobrenome',
        email: 'E-mail',
        userName: 'Nome de usuário',
        phone: 'Telefone',
        department: 'Departamento',
        profile: 'Perfil',
        language: 'Idioma',
        timezone: 'Fuso horário',
        currentProfile: 'Perfil atual',
      },
      blocked: 'Bloqueado',
      timezoneGroups: {
        utc: 'Deslocamento UTC',
        iana: 'Fuso horário regional (IANA)',
      },
      resetting: 'Redefinindo…',
      resetPassword: 'Redefinir senha',
      create: 'Criar usuário',
      passwordDialog: {
        defaultTitle: 'Senha temporária',
        resetTitle: 'Senha redefinida',
        createTitle: 'Usuário criado',
        hint: 'Repasse esta senha temporária ao usuário. Ela não será exibida novamente.',
        copied: 'Senha copiada para a área de transferência.',
        copyPassword: 'Copiar senha',
        copiedButton: 'Copiado',
        copy: 'Copiar',
        understood: 'Entendi',
      },
      errors: {
        phoneInvalid: 'Informe um telefone válido ou limpe o campo.',
        profilesLoadFailed: 'Não foi possível carregar os perfis da empresa.',
        resetFailed: 'Não foi possível redefinir a senha.',
        requiredFields: 'Preencha nome, sobrenome, e-mail e nome de usuário.',
        createFailed: 'Não foi possível criar o usuário.',
        updateFailed: 'Não foi possível atualizar o usuário.',
        licenseLimit: 'Limite de usuários da licença atingido.',
        duplicate: 'E-mail ou nome de usuário já existem nesta empresa.',
        notFound: 'Empresa ou usuário não encontrado.',
      },
    },
    integrations: {
      subtitle: 'SAFR e Lenel',
      safr: {
        loading: 'Carregando configuração SAFR…',
        autoSync: 'Sincronização automática com SAFR',
        authHint: 'O campo Autorização não é preenchido automaticamente por segurança.',
        paramsTitle: 'Parâmetros SAFR',
        authPlaceholder: 'Informe a autorização para salvar',
        saveSuccess: 'Configuração SAFR salva com sucesso.',
        errors: { authRequired: 'Informe a autorização (não é exibida após salvar).' },
      },
      lenel: {
        loading: 'Carregando configuração Lenel…',
        authInfo: 'Informações de autenticação da integração Lenel',
        passwordHint: 'A senha não é exibida após salvar. Informe novamente para alterar.',
        enabled: 'Habilitado',
        saveSuccess: 'Configuração Lenel salva.',
        errors: { passwordRequired: 'Informe a senha (nunca é exibida após salvar).' },
      },
    },
  },
  operators: {
    title: 'Gestão de Operadores',
    subtitle: 'Gerencie operadores alocados, horas de suporte, notas de serviço e timesheets',
    summaryAria: 'Resumo',
    stats: {
      activeOperators: 'Operadores ativos',
      allocatedHours: 'Horas alocadas',
      usedHours: '{{used}}h utilizadas ({{pct}}%)',
      pendingNotes: 'Notas pendentes',
      pendingApprovals: 'Aprovações pendentes',
    },
    tabs: {
      operators: 'Operadores',
      hours: 'Horas',
      notes: 'Notas',
      timesheet: 'Timesheet',
      base: 'Base',
      profile: 'Meu Perfil',
    },
    operadores: {
      searchPlaceholder: 'Buscar por nome, email ou função...',
      newButton: 'Novo Operador',
      filters: 'Filtros:',
      filterStatusAria: 'Filtrar por status',
      allStatus: 'Todos status',
      filterClientAria: 'Filtrar por cliente',
      allClients: 'Todos clientes',
      count: '{{displayed}} de {{total}} operadores',
      retry: 'Tentar novamente',
      loading: 'Carregando operadores…',
      empty: 'Nenhum operador para exibir.',
      table: {
        operator: 'Operador',
        role: 'Função',
        clients: 'Clientes',
        hours: 'Horas',
        status: 'Status',
      },
      none: 'Nenhum',
      active: 'Ativo',
      inactive: 'Inativo',
      actionsAria: 'Ações do operador',
      edit: 'Editar',
      remove: 'Remover',
      form: {
        editTitle: 'Editar Operador',
        createTitle: 'Novo Operador',
        subtitle: 'Preencha as informações do operador e os clientes vinculados (opcional).',
        closeAria: 'Fechar',
        name: 'Nome',
        email: 'E-mail',
        role: 'Função',
        rolePlaceholder: 'Ex.: Suporte Nível 2',
        status: 'Status',
        clientsSection: 'Clientes (companies)',
        clientsHint: 'Opcional. Nenhuma seleção equivale a nenhum cliente.',
        noCompanies: 'Nenhuma empresa listada. Verifique GET /company e permissões.',
        cancel: 'Cancelar',
        saving: 'Salvando…',
        saveChanges: 'Salvar alterações',
        create: 'Criar Operador',
        errorRequired: 'Preencha nome, e-mail e função.',
      },
    },
    horas: {
      title: 'Licenciamento de Horas de Suporte e Implantação',
      newPackage: 'Novo Pacote de Horas',
      retry: 'Tentar novamente',
      loading: 'Carregando pacotes de horas...',
      empty: 'Nenhum pacote de horas cadastrado.',
      clientsCount: '{{count}} cliente(s)',
      available: 'Disponível: {{hours}}h',
      addHours: 'Adicionar horas',
      total: 'Total',
      remaining: 'Restam {{hours}}h disponíveis',
      form: {
        createTitle: 'Novo Pacote de Horas',
        subtitle: 'Defina operador, horas totais e as companies com seus limites.',
        operator: 'Operador',
        select: 'Selecione...',
        totalHours: 'Total de Horas',
        companiesTitle: 'Companies do Pacote',
        companiesHint: 'Adicione uma ou mais companies com maxHours.',
        addCompany: '+ Company',
        selectCompany: 'Selecione company...',
        maxHours: 'maxHours',
        cancel: 'Cancelar',
        create: 'Criar Pacote',
        saving: 'Salvando...',
      },
      addHoursModal: {
        title: 'Adicionar horas',
        hours: 'Horas',
        cancel: 'Cancelar',
        confirm: 'Adicionar',
      },
      errors: {
        packageRequired:
          'Selecione operador, total de horas e ao menos uma company com carga válida.',
        duplicateCompany: 'Não repita a mesma company no pacote.',
        hoursExceeded: 'A soma das horas por company não pode ultrapassar o total do pacote.',
        invalidHours: 'Informe uma quantidade de horas válida.',
      },
    },
    notas: {
      title: 'Emissão de Notas de Serviços',
      newNote: 'Nova Nota de Serviço',
      table: {
        number: 'Número',
        client: 'Cliente',
        operator: 'Operador',
        hours: 'Horas',
        value: 'Valor',
        date: 'Data',
        status: 'Status',
      },
      status: {
        paid: 'Paga',
        issued: 'Emitida',
        pending: 'Pendente',
      },
      actionsAria: 'Ações',
    },
    timesheet: {
      title: 'Timesheet',
      newEntry: 'Novo Lançamento',
      table: {
        date: 'Data',
        operator: 'Operador',
        client: 'Cliente',
        hours: 'Horas',
        description: 'Descrição',
        status: 'Status',
      },
      status: {
        approved: 'Aprovado',
        pending: 'Pendente',
      },
    },
    base: {
      title: 'Base de Conhecimento',
      subtitle: 'Artigos de autoatendimento com busca semântica IA',
      refreshAria: 'Atualizar',
      listViewAria: 'Lista',
      gridViewAria: 'Grade',
      newArticle: 'Novo Artigo',
      searchPlaceholder: 'Buscar artigos...',
      emptyArticles: 'Nenhum artigo encontrado',
      createFirstArticle: 'Criar primeiro artigo',
      stats: {
        total: 'Total Artigos',
        published: 'Publicados',
        views: 'Visualizações',
        helpful: 'Avaliações Úteis',
      },
      subTabs: {
        browse: 'Navegar',
        aiSearch: 'Busca IA',
      },
    },
    perfil: {
      title: 'Meu Perfil',
      tabs: {
        personal: 'Dados Pessoais',
        preferences: 'Preferências',
      },
      loadError: 'Não foi possível carregar seus dados. Atualize a página ou tente mais tarde.',
      personalInfo: {
        title: 'Informações Pessoais',
        subtitle: 'Atualize suas informações de perfil e contato',
        photoHint: 'Clique para alterar a foto (máx. 2MB)',
        active: 'Ativo',
        fullName: 'Nome completo',
        username: 'Nome de usuário',
        email: 'E-mail',
        timezonePlaceholder: 'Ex: UTC+03:00',
        saveError:
          'Não foi possível salvar. Verifique o nome de usuário e o tamanho da imagem (máx. 2MB).',
        emailLocked: 'O e-mail não pode ser alterado',
        phone: 'Telefone',
        department: 'Departamento',
        language: 'Idioma',
        timezone: 'Fuso horário',
        saveSuccess: 'Dados atualizados com sucesso.',
      },
      notifications: {
        title: 'Notificações',
        subtitle: 'Configure como deseja receber alertas',
        system: 'Notificações do Sistema',
        systemHint: 'Receber notificações de novos chamados',
        email: 'Notificações por E-mail',
        emailHint: 'Receber resumos diários por e-mail',
        sound: 'Alertas Sonoros',
        soundHint: 'Tocar som ao receber novos chamados',
      },
      appearance: {
        title: 'Aparência',
        subtitle: 'Personalize a aparência do sistema',
        darkMode: 'Modo Escuro',
        darkModeHint: 'Alternar entre tema claro e escuro',
        compactView: 'Visualização Compacta',
        compactViewHint: 'Mostrar mais chamados na tela',
        language: 'Idioma',
        languageHint: 'Selecione o idioma do sistema',
      },
      workflow: {
        title: 'Fluxo de Trabalho',
        subtitle: 'Configure seu comportamento padrão',
        autoAssign: 'Auto-atribuição',
        autoAssignHint: 'Atribuir automaticamente novos chamados dos seus clientes',
      },
      saved: 'Salvo',
    },
  },
  param: {
    title: 'Parametrizações',
    subtitle: 'Configure parâmetros, módulos e analíticos do sistema.',
    searchPlaceholder: 'Buscar verticais, módulos...',
    tabs: {
      verticals: 'Verticais',
      modules: 'Módulos',
      analytics: 'Analíticos',
    },
    verticals: {
      title: 'Verticais do sistema',
      newButton: '+ Nova Vertical',
      loading: 'Carregando verticais...',
      empty: 'Nenhuma vertical encontrada.',
      filterHint:
        'Clique nos cards para filtrar quais verticais aparecem na lista de módulos abaixo. Pode selecionar mais de uma.',
      selectAll: 'Marcar todas',
      deselectAll: 'Desmarcar todas',
      filterAria: 'Filtrar vertical {{name}}',
      deactivated: 'Desativada',
      activeSummary: '{{active}}/{{total}} ativos',
      selectVerticalHint: 'Selecione uma ou mais verticais acima para ver os módulos associados.',
      expandModulesAria: 'Expandir ou recolher módulos de {{name}}',
      activateAll: 'Ativar Todos',
      deactivateAll: 'Desativar Todos',
      editAria: 'Editar vertical',
      deleteAria: 'Excluir vertical',
      noModules: 'Nenhum módulo associado a esta vertical.',
      viewMarkdownAria: 'Visualizar markdown do módulo',
      form: {
        editTitle: 'Editar Vertical',
        createTitle: 'Nova Vertical',
        subtitle: 'Informe nome, descrição, cor e status da vertical.',
        name: 'Nome da Vertical',
        icon: 'Ícone',
        description: 'Descrição',
        color: 'Cor da vertical (opcional)',
        colorHint: 'Se vazio, uma cor aleatória será gerada.',
        status: 'Status',
        active: 'Ativa',
        inactive: 'Inativa',
        associatedModules: 'Módulos Associados ({{count}} selecionado(s))',
        noModulesAvailable: 'Nenhum módulo disponível para associação.',
        cancel: 'Cancelar',
        saving: 'Salvando...',
        saveChanges: 'Salvar alterações',
        create: 'Criar vertical',
        errors: {
          nameRequired: 'Informe nome e descrição da vertical.',
          invalidColor: 'Cor inválida. Use #RGB ou #RRGGBB.',
        },
      },
      delete: {
        title: 'Confirmar exclusão',
        message: 'Deseja realmente remover a vertical {{name}}?',
        cancel: 'Cancelar',
        confirm: 'Excluir',
        deleting: 'Excluindo...',
      },
    },
    modules: {
      title: 'Módulos do sistema',
      expandAll: 'Expandir tudo',
      collapseAll: 'Colapsar tudo',
      newCategory: '+ Nova Categoria',
      newModule: '+ Novo Módulo',
      loading: 'Carregando módulos e categorias...',
      empty: 'Nenhum módulo encontrado.',
      expandCategoryAria: 'Expandir ou recolher categoria {{name}}',
      editCategoryAria: 'Editar categoria',
      enableModuleAria: 'Ativar módulo',
      disableModuleAria: 'Desativar módulo',
      viewDetailsAria: 'Ver detalhes do módulo',
      editAria: 'Editar módulo',
      deleteAria: 'Excluir módulo',
      noCategory: 'Sem categoria',
      view: {
        title: 'Detalhes do Módulo',
        subtitle: 'Visualização completa dos dados do módulo (somente leitura).',
        loading: 'Carregando dados do módulo...',
        name: 'Nome',
        category: 'Categoria',
        categoryPathPrefix: 'Prefixo da rota (categoria)',
        modulePath: 'Segmento da rota (módulo)',
        activationPath: 'Rota de ativação',
        activationPathMissing:
          'Não definida: é necessário prefixo na categoria e segmento de rota no módulo. O backend compõe automaticamente quando ambos existem.',
        description: 'Descrição',
        markdown: 'Treinamento / Documentação (Markdown)',
        attachments: 'Anexos',
        noAttachments: 'Nenhum anexo disponível.',
        close: 'Fechar',
      },
      create: {
        title: 'Novo Módulo',
        subtitle: 'Crie um novo módulo do sistema e associe uma categoria (opcional).',
        name: 'Nome do módulo',
        description: 'Descrição',
        category: 'Categoria',
        noCategory: 'Sem categoria',
        pathSegment: 'Segmento da rota (módulo)',
        pathHint: 'Um único segmento, sem "/" nem espaços. Opcional.',
        pathPlaceholder: 'ex.: reports',
        sectionName: 'Nome da seção (menu)',
        sectionPlaceholder: 'Padrão: nome da categoria',
        menuIcon: 'Ícone no menu',
        activationPreview: 'Pré-visualização da rota de ativação',
        cancel: 'Cancelar',
        saving: 'Salvando...',
        create: 'Criar Módulo',
        errors: {
          nameRequired: 'Informe o nome do módulo.',
        },
      },
      edit: {
        title: 'Editar Módulo',
        subtitle:
          'Atualize os dados do módulo e mantenha um material de treinamento/documentação em markdown.',
        loading: 'Carregando dados completos do módulo...',
        pathHint:
          'Um único segmento, sem "/" nem espaços. Deixe vazio para remover o segmento (PUT envia valor vazio como remoção).',
        sectionName: 'Nome da seção (menu)',
        markdownTab: {
          write: 'Editar',
          preview: 'Preview',
        },
        attachments: {
          title: 'Anexos',
          uploading: 'Enviando...',
          add: '+ Adicionar arquivo',
          hint: 'Use attachment:id-do-anexo no markdown, ou clique em "Inserir no markdown".',
          empty: 'Nenhum anexo adicionado.',
          pendingUpload: ' · pendente de upload',
          insert: 'Inserir no markdown',
          removeAria: 'Remover anexo',
          remote: 'Remoto',
          idLabel: 'ID',
        },
        cancel: 'Cancelar',
        saving: 'Salvando...',
        saveChanges: 'Salvar alterações',
        errors: {
          nameRequired: 'Informe o nome do módulo.',
          waitUpload: 'Aguarde o upload dos anexos terminar para salvar as alterações.',
          pendingAttachments:
            'Existem anexos pendentes de upload. Reenvie os arquivos antes de salvar.',
          saveBeforeInsert:
            'Salve o módulo para concluir o upload antes de inserir este anexo no markdown.',
        },
      },
      delete: {
        title: 'Confirmar exclusão',
        message: 'Deseja realmente remover o módulo {{name}}?',
        cancel: 'Cancelar',
        confirm: 'Excluir',
        deleting: 'Excluindo...',
      },
      category: {
        createTitle: 'Nova Categoria',
        createSubtitle: 'Crie uma categoria para organização dos módulos.',
        editTitle: 'Editar Categoria',
        editSubtitle:
          'Altere o nome e o prefixo da rota usado na URL de ativação dos módulos desta categoria.',
        name: 'Nome da categoria',
        pathPrefix: 'Prefixo da rota (categoria)',
        pathHint:
          'Primeiro segmento da URL de ativação. Um único segmento, sem "/" nem espaços. Opcional.',
        pathHintEdit: 'Deixe vazio para remover o prefixo (o backend interpreta como remoção).',
        pathPlaceholder: 'ex.: analytics',
        sectionName: 'Nome da seção (menu)',
        sectionPlaceholder: 'Ex.: Facial',
        svgIcon: 'Ícone (SVG)',
        svgFilter: 'Filtrar por pasta ou arquivo…',
        svgCatalogHint:
          'Catálogo em src/assets/svg. Enviado à API no campo svg como ./assets/media/svg/…',
        cancel: 'Cancelar',
        saving: 'Salvando...',
        create: 'Criar Categoria',
        save: 'Salvar',
        errors: {
          nameRequired: 'Informe o nome da categoria.',
          invalidIcon: 'Selecione um ícone válido da lista.',
          maxLength: '{{field}} pode ter no máximo 128 caracteres.',
          invalidSegment:
            '{{field}} deve ser um único segmento de URL (sem barra ou espaços em branco).',
        },
      },
      activationHint:
        'A rota de ativação (prefixo da categoria + segmento do módulo) só aparece quando a categoria selecionada tiver prefixo e o módulo tiver segmento de rota.',
      markdownPlaceholder: 'Descreva aqui o treinamento e uso do módulo...',
    },
    analytics: {
      title: 'Catálogo de analíticos',
      newType: '+ Novo Tipo',
      newAnalytic: '+ Novo Analítico',
      loading: 'Carregando analíticos...',
      empty: 'Nenhum analítico encontrado.',
      count: '{{count}} analíticos',
      details: 'Detalhes',
      noManufacturers: 'Sem fabricantes',
      coverage: '{{integrated}}/{{total}}',
      typeForm: {
        title: 'Novo Tipo de Analítico',
        subtitle: 'Cadastre uma categoria para agrupar analíticos.',
        name: 'Nome',
        code: 'Código',
        description: 'Descrição',
        cancel: 'Cancelar',
        saving: 'Salvando...',
        save: 'Salvar',
        errors: {
          required: 'Informe nome e código do tipo de analítico.',
        },
      },
      analyticForm: {
        title: 'Novo Analítico',
        subtitle: 'Preencha os dados para adicionar um novo analítico ao catálogo.',
        code: 'Código',
        name: 'Nome',
        category: 'Categoria',
        icon: 'Ícone',
        shortDescription: 'Descrição Curta',
        fullDescription: 'Detalhes Completos',
        useCases: 'Casos de Uso',
        compatibleManufacturers: 'Fabricantes Compatíveis',
        select: 'Selecione',
        cancel: 'Cancelar',
        saving: 'Salvando...',
        save: 'Salvar',
        errors: {
          required: 'Preencha código, nome e categoria.',
        },
      },
      detailsPanel: {
        title: 'Detalhes do Analítico',
        description: 'Descrição',
        noDescription: 'Sem descrição cadastrada.',
        useCases: 'Casos de uso',
        manufacturerCompatibility: 'Compatibilidade com Fabricantes',
        yes: 'SIM',
        no: 'NÃO',
      },
    },
    iconPicker: {
      noIcon: 'Sem ícone',
    },
  },
  tickets: {
    title: 'Central de Chamados',
    subtitle: 'Gerencie e acompanhe todos os chamados de suporte dos clientes licenciados.',
    summaryAria: 'Resumo de chamados',
    operator: {
      title: 'Operador Logado',
      loading: 'Carregando...',
      onlyMine: 'Meus chamados ({{count}})',
      all: 'Todos os operadores',
      hint: 'Selecione uma empresa no filtro para listar todos os operadores cadastrados nela.',
    },
    stats: {
      total: 'Total de Chamados',
      open: 'Em Aberto',
      closed: 'Finalizados',
      highPriority: 'Alta Prioridade',
      unansweredToday: 'Sem resposta hoje',
    },
    severity: {
      low: 'Baixa',
      medium: 'Média',
      high: 'Alta',
    },
    priority: {
      low: 'Baixa',
      medium: 'Média',
      high: 'Alta',
      urgent: 'Urgente',
    },
    export: 'Exportar',
    exportFilename: 'chamados',
    refresh: 'Atualizar',
    view: {
      compact: 'Visualização compacta',
      list: 'Visualização em lista',
      grid: 'Visualização em grade',
    },
    searchPlaceholder: 'Buscar por título, descrição, local ou empresa...',
    filters: {
      search: 'Buscar',
      company: 'Empresa',
      status: 'Status',
      type: 'Tipo',
      severity: 'Prioridade',
      from: 'Data inicial',
      to: 'Data final',
      clear: 'Limpar filtros',
      allCompanies: 'Todas as empresas',
      allStatuses: 'Todos os status',
      allTypes: 'Todos os tipos',
      allSeverities: 'Todas as prioridades',
    },
    tabs: {
      all: 'Todos',
      open: 'Abertos',
      closed: 'Finalizados',
    },
    newButton: 'Novo Chamado',
    loading: 'Carregando chamados...',
    empty: 'Nenhum chamado encontrado.',
    table: {
      title: 'Chamado',
      company: 'Empresa',
      location: 'Local',
      type: 'Tipo',
      severity: 'Prioridade',
      status: 'Status',
      createdAt: 'Criado em',
      updatedAt: 'Atualizado em',
    },
    detail: {
      close: 'Fechar',
      status: 'Status:',
      loadingConversation: 'Carregando conversa...',
      noMessages: 'Nenhuma mensagem ainda.',
      replyPlaceholder: 'Escreva uma resposta...',
      send: 'Enviar',
      sending: 'Enviando...',
      attachment: 'Anexo',
      slaDueAt: 'SLA até',
      assignee: 'Responsável',
      internalNote: 'Nota interna',
      markInternal: 'Marcar como nota interna (não visível ao cliente no futuro)',
      linkSolution: 'Vincular solução (opcional)',
      linkSolutionHint:
        'Ajuda a medir a efetividade das soluções do catálogo de Problemas & Soluções.',
      noSolution: 'Sem solução vinculada',
    },
    form: {
      title: 'Novo Chamado',
      subtitle: 'Abra um chamado de suporte em nome de um cliente licenciado.',
      sections: {
        company: 'Informações da Empresa',
        details: 'Detalhes do Chamado',
      },
      company: 'Empresa',
      selectCompany: 'Selecione a empresa',
      location: 'Local',
      selectLocation: 'Selecione o local',
      loadingLocations: 'Carregando locais...',
      type: 'Tipo',
      status: 'Status',
      severity: 'Prioridade',
      priority: 'Prioridade',
      assignee: 'Responsável (time Fisital)',
      unassigned: 'Sem responsável',
      titleField: 'Assunto',
      titlePlaceholder: 'Descreva brevemente o problema',
      description: 'Descrição',
      descriptionPlaceholder: 'Detalhes adicionais sobre o chamado...',
      attachments: 'Evidências (screenshots, capturas de tela)',
      cancel: 'Cancelar',
      saving: 'Salvando...',
      create: 'Criar chamado',
      errors: {
        required: 'Preencha empresa, local, tipo, status, título e descrição.',
        attachmentsFailed: 'Chamado criado, mas o envio dos anexos falhou: {{message}}',
      },
    },
  },
  knowledgeBase: {
    title: 'Base de Conhecimento',
    subtitle: 'Catálogo de problemas e soluções alimentado pelo histórico de chamados.',
    searchPlaceholder: 'Buscar por nome, módulo ou produto...',
    newCategory: 'Nova categoria',
    empty: 'Nenhuma categoria de problema cadastrada ainda.',
    occurrences: 'Ocorrências',
    solutions: 'Soluções',
    noSolutions: 'Nenhuma solução cadastrada para esta categoria ainda.',
    newSolution: 'Nova solução',
    addSolution: 'Adicionar solução',
    removeCategory: 'Remover categoria',
    activate: 'Reativar',
    deactivate: 'Desativar',
    loadError: 'Não foi possível carregar a base de conhecimento.',
    confirmRemoveCategory: 'Remover a categoria "{{name}}"? Isso remove também suas soluções.',
    confirmRemoveSolution: 'Remover a solução "{{title}}"?',
    severity: {
      low: 'Baixa',
      medium: 'Média',
      high: 'Alta',
    },
    form: {
      name: 'Nome do problema',
      module: 'Módulo',
      product: 'Produto',
      description: 'Descrição',
      solutionTitle: 'Título da solução',
      tags: 'Tags (separadas por vírgula)',
      steps: 'Passos (um por linha)',
    },
    table: {
      title: 'Solução',
      usage: 'Usos',
      effectiveness: 'Efetividade',
      avgTime: 'Tempo médio',
    },
  },
};
